export default "__VITE_ASSET__36633f24__"